<div class="page-sub-section">
   <div class="contentBox">
      <div class="sectionTitle margin-b-20 wow fadeInUp"
           data-wow-duration="500ms" data-wow-delay="50ms">Mission Capital
      </div>
      <div class="description">
         <div class="margin-b-15 wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="100ms">
            Mission Capital is responsible for investing Mission Holdings’ liquid capital via a portfolio of public
            markets, direct investments and external managers.
         </div>
         <div class="margin-b-15 wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
            The direct portfolio ranges from public holdings in the largest companies in the world to private seed-level
            investments in start-up companies. The portfolio’s largest sector concentration is technology, largely
            clustered around Mission Holdings’ areas of deepest expertise in software & services, media & consumer tech,
            and Fintech. Mission Capital additionally has investments in a range of other sectors (including Life
            Sciences, Consumer goods and Financials). Geographically, while the majority of our portfolio is in
            companies based in the United States, we also have a meaningful amount of invested capital in both Europe
            and Asia. Our investments typically fall within key thematic areas in which through deep fundamental
            research we are able to attain high conviction in the company’s growth and business quality. Our targeted
            investment horizon is 5+ years.
         </div>
         <div class=" wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
            Mission Capital's external manager portfolio ranges from Public Equity managers to participation in Venture
            Capital and Private Equity funds. With our ability to make connections to both industry, institutional
            investors, and best-in-class asset managers, we aim to be high quality value-added partners to our external
            manager partners.
         </div>
      </div>
   </div>
</div>

<app-looking-for></app-looking-for>
